import { all } from 'redux-saga/effects';
import auth from './auth/saga';
import casesSagas from './mycases/saga';

import companyDetails from './companyDetails/saga';

export default function* rootSaga() {
  yield all([auth(),casesSagas(), companyDetails()]);
}
